import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
import BootstrapVue from "bootstrap-vue";
// eslint-disable-next-line no-unused-vars
import VueLoader from "./loader";
import loadExporting from "highcharts/modules/exporting";
import Highcharts from "highcharts";
import HighchartsTheme from "./highchart/theme.js";
import VueHighcharts from "vue-highcharts";
import VueProgressBar from "vue-progressbar";
import Element from "element-ui";
import lang from "element-ui/lib/locale/lang/en";
import locale from "element-ui/lib/locale";
import Trend from "vuetrend";
import "element-ui/lib/theme-chalk/index.css";
import Notifications from "element-ui";
import VueBus from "vue-bus";

import "@fortawesome/fontawesome-pro/css/all.css";
import "@fortawesome/fontawesome-pro/js/all.js";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

//import 'styles/style.scss'
require("./assets/styles/style.scss");

loadExporting(Highcharts);
Highcharts.theme = HighchartsTheme;
Highcharts.setOptions(Highcharts.theme);

Vue.use(VueLoader);
Vue.use(VueHighcharts, { Highcharts });

Vue.use(VueProgressBar, {
  color: "#38ed03",
  height: "4px"
});
Vue.use(Trend);
Vue.use(Notifications);

locale.use(lang);
Vue.use(Element);

Vue.use(BootstrapVue);
Vue.use(VueBus);

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>",
  vueLoading: new VueLoader({ registerComponents: true }),
  store
});
